import { motion } from "motion/react"
import { BsCheckCircle, BsXCircle } from "react-icons/bs"
import { ClassNames } from "../../../../Util/ClassNames"
import './ExerciseMessage.scss'

export function ExerciseMessage(props:{answerStatus:boolean|null, message:string|JSX.Element, forceRefresh?:boolean}){
    const scale:number = 0
    const animateScale:number = 1
    const duration:number = 0.3
    const key:number = (props.forceRefresh) ? Date.now() : 0
    const getClassNames = () => {
        const classNames:ClassNames = new ClassNames(['message'])
        if(props.answerStatus !== null){
            const className:string = (props.answerStatus) ? 'correct' : 'incorrect'
            classNames.addClass(className)
        }
        return classNames.toString()
    }
    const getIcon = ():React.ReactNode => {
        if(props.answerStatus !== null){
            const icon:JSX.Element = (props.answerStatus) ? <BsCheckCircle/> : <BsXCircle />
            return icon
        }
        return null
    }
    return(
        <div className='exercise-message'>
            <motion.div key={key} initial={{scale:scale}} animate={{scale:animateScale}} transition={{duration:duration}} className={getClassNames()}>
                <div className='container'>
                    <span>{props.message}</span>
                    <span>{getIcon()}</span>
                </div>
            </motion.div>
        </div> 
    )
}